import apiService from '@/utils/api-client'
import { SIDEBAR_SHRUNK_STORAGE_KEY } from './state'

export default {
    // Collapsing the sidebar is also something pages do on their own — the
    // graph does it when an element is selected, the report to make room. Those
    // go through SET_SHRUNK directly; only a deliberate toggle lands here, so a
    // single risk report can't rewrite the user's preference.
    setShrunkPreference({ commit }, value) {
        commit('SET_SHRUNK', value)

        try {
            localStorage.setItem(SIDEBAR_SHRUNK_STORAGE_KEY, String(value))
        } catch (error) {
            // a full or disabled store just means the preference isn't kept
        }
    },
    // eslint-disable-next-line no-unused-vars
    async getNotificationsCount({commit}) {
        try {
            const data = apiService.get('labeling/getNotificationsCount')
            return data
        } catch (error) {
            console.error(error)
        }
    },
}
